export const gst_details_gstin_note =
    "Note: Adding your GST Number will automatically update the billing state for this booking";
